import joi, { optional } from '@hapi/joi';
import {
    AppropriatenessTestDetails,
} from './types';



export const AppropriatenessTestSchema = joi
    .object<AppropriatenessTestDetails>()
    .unknown(true)
    .keys({
        isSummaryInstructionOption: joi
            .number()
            .required()
            .error((err: any) => 'Summary Instruction Option is required'),
            isFinancialChecked: joi.boolean().valid(true).required().error((err: any) => 'You must check at least one financial instrument field'),
    });
